import React, {useState, useEffect, useRef} from "react";
import { RadioInput } from "sr/helpers/ui-components/RadioInput";
import { FormattedMessage, useIntl } from "react-intl";
import { RateRange } from "app/pages/jobs/component/workOrder/RateRange";
import { set } from "date-fns";
import { useParams } from "react-router-dom";
import getLabelByValue from "sr/helpers/functions/getLabelByValue";
interface propsType {
  setStartTime:(e:any)=> void,
  setEndTime:(e:any)=> void,
  setMinRange:(e:any) => void,
  setMaxRange:(e:any)=> void
}
export const CleanerFilter = (props:propsType) => {
    const [rateRange, setRateRange] = useState<any>()
    const [shouldReset, setShouldReset] = useState(false)
    const intl = useIntl()

      const params = useParams()
      const {from, to} = params
    
 const TimeData = [
  { label: "Morning (08:00 AM - 12:00 PM)", value: "08:00-12:00" },
  { label: "Afternoon (12:00 PM - 05:00 PM)", value: "12:00-17:00" },
  { label: "Evening (05:00 PM - 09:00 PM)", value: "17:00-21:00" },
];
const [TimeofDay, setTimeofDay] = useState("")
  useEffect(()=> {
    if(TimeofDay) {
      const time = TimeofDay.split('-')
      props?.setStartTime(time[0])
      props?.setEndTime(time[1])
    }
  }, [TimeofDay])

    const HandleRangeData = (data)=> {
      if(data?.minRange==1 && data?.maxRange==1000) return
          setRateRange(data)
          props?.setMinRange(data?.minRange)
          props?.setMaxRange(data?.maxRange)   
          setShouldReset(false)  
    }
    const handleReset = ()=> {
      setRateRange({})
      setTimeofDay('')
      setShouldReset(true)
      props?.setMinRange(1)
          props?.setMaxRange(1000)  
          props?.setStartTime(from || '')
      props?.setEndTime(to || '') 
    }
  return (
    <div className="col-span-4 bg-white border border-neutral-300 rounded-lg px-3 mb-3 lg:mb-0 h-fit">
      <div className="flex justify-between">
        <div className="flex space-x-2">
        {TimeofDay && 
        <div className="rounded-3xl my-1 border border-neutral-200 relative flex justify-center items-center">
            <span className="text-sm	 text-gray-500  font-bold px-2 py-1 leading-none">{getLabelByValue(TimeofDay, TimeData)}</span>
<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 font-bold absolute -top-2 right-0 cursor-pointer" onClick={()=> {setTimeofDay(''); props?.setStartTime(from || ''); props?.setEndTime(to || '')}}>
  <path strokeLinecap="round" strokeLinejoin="round" d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
</svg>


          </div>
}

{Object.values(rateRange || {})?.length >=1 && 
        <div className="rounded-3xl my-1 border border-neutral-200 relative flex justify-center items-center">
            <span className="text-sm	 text-gray-500  font-bold px-2 py-1 leading-none">${rateRange?.minRange} - ${rateRange?.maxRange}</span>
<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 font-bold absolute -top-2 right-0 cursor-pointer" onClick={()=> setRateRange('')}>
  <path strokeLinecap="round" strokeLinejoin="round" d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
</svg>


          </div>
}
</div>
        <p onClick={handleReset} className="cursor-pointer text-base font-bold text-[#0078ae] pt-3 px-3">Reset</p>
      </div>
    <div className="p-5 pt-2">
      <p className="text-base font-bold pb-3"><FormattedMessage id="INDIVIDUAL.CLEANERS.FILTER.TIMEOFDAY." defaultMessage="Time of Day" /></p>
        {TimeData.map((item, index) => (
            <RadioInput
    key={index}
  name="filter"
  value={item.value}
  checked={TimeofDay === item.value}
  onChange={(e)=> setTimeofDay(e.target.value)}
  label={item.label}
/>
        ))}
    
    </div>
  <p className="border-b text-center leading-[1.5px] border-neutral-300"></p>

     <div className="p-5">
        <p className="font-bold">Rate Range</p>
    <RateRange shouldReset={shouldReset} nohideShow={true} viewmore={false} SearchShow = {false} Title = {intl.formatMessage({id:'CLEANER.WORKORDER.FILTER.RATERANGE', defaultMessage:'Rate Range'})} HandleRangeData={HandleRangeData}/>
 
 </div>
      <div className=" border-b border-neutral-300 p-5">
      </div>
    </div>
  );
};
